module.exports = __webpack_public_path__ + "img/teacher02.5ebe8656.png";